__turbopack_context__.v({
  "bar": "ItineraryStickyBar-module__22qlKa__bar",
  "bookingActions": "ItineraryStickyBar-module__22qlKa__bookingActions",
  "bottomRow": "ItineraryStickyBar-module__22qlKa__bottomRow",
  "cta": "ItineraryStickyBar-module__22qlKa__cta",
  "iconButton": "ItineraryStickyBar-module__22qlKa__iconButton",
  "inner": "ItineraryStickyBar-module__22qlKa__inner",
  "metaLine": "ItineraryStickyBar-module__22qlKa__metaLine",
  "price": "ItineraryStickyBar-module__22qlKa__price",
  "priceButton": "ItineraryStickyBar-module__22qlKa__priceButton",
  "priceSuffix": "ItineraryStickyBar-module__22qlKa__priceSuffix",
  "tabsSlot": "ItineraryStickyBar-module__22qlKa__tabsSlot",
  "title": "ItineraryStickyBar-module__22qlKa__title",
  "topActions": "ItineraryStickyBar-module__22qlKa__topActions",
  "topRow": "ItineraryStickyBar-module__22qlKa__topRow",
  "tripMeta": "ItineraryStickyBar-module__22qlKa__tripMeta",
});
